module.exports = __webpack_public_path__ + "img/rotationArrow.01219ab4.png";